enum Roles {
  HRNYA = '98324',
  HEAD_OF_SELLERS = '76399',
  ADMIN = '93160',
  SUPER_ADMIN = '93260',
  CUSTOM = '66966',
  PIDOR = '67270',
  STANDART_USER = '67274',
}

export { Roles };
